import * as React from "react";

import { DashboardKnowledgeTestModel } from "models/ApiModels";

import { TableRow, TableCell } from "@mui/material";

import MuiLink from "components/MuiExtras/MuiLink";
import { GlobalClassKeys } from "assets/jss/common-styles";

export interface RenderTestModelListEvents {
    onSelectTest?: (testId: string, title: string) => void;
}

interface IProps extends RenderTestModelListEvents {
    indexOffset: number;
    items: DashboardKnowledgeTestModel[];
    onDrillDown?: (item: DashboardKnowledgeTestModel) => void;
}

export const RenderTestModelList: React.FC<IProps> = (props) => {

    return (
        <>
            {
                props.items.map((v, index) => {

                    var rightValue = v.percent != null ? `${v.percent.toFixed(1)}%` : v.total != null ? v.total : null;

                    return (
                        <TableRow key={index}>
                            <TableCell style={{ width: 1 }} className={GlobalClassKeys.bold}>
                                {props.indexOffset + index + 1}
                            </TableCell>

                            <TableCell>
                                {
                                    props.onSelectTest
                                        ? <MuiLink color="secondary" onClick={() => props.onSelectTest(v.testId, v.title)}>{v.title}</MuiLink>
                                        : <b>{v.title}</b>
                                }

                            </TableCell>

                            {
                                rightValue != null &&
                                <TableCell align="right">
                                    {
                                        props.onDrillDown
                                            ? <MuiLink color="secondary" onClick={() => props.onDrillDown(v)}>{rightValue.toLocaleString()}</MuiLink>
                                            : rightValue.toLocaleString()
                                    }
                                </TableCell>
                            }
                        </TableRow>
                    );
                })
            }
        </>
    );
}

